module.exports = __webpack_public_path__ + "img/product1.60da4da4.jpg";